export default {
    strength: [
        {
            name: "Ataque Físico",
            baseValue: 2.62,
            highValue: 1.31,
            displayValue: 0,
        },
        {
            name: "Ataque Duplo",
            baseValue: 0.05,
            highValue: 0.025,
            displayValue: 0,
        },
        {
            name: "Dano Crítico",
            baseValue: 0.2,
            highValue: 0.1,
            displayValue: 0,
        },
        {
            name: "Perfuração Física",
            baseValue: 0.03,
            highValue: 0.015,
            displayValue: 0,
        },
    ],
    agility: [
        {
            name: "Ataque Físico",
            baseValue: 2.62,
            highValue: 1.31,
            displayValue: 0,
        },
        {
            name: "Ataque Crítico",
            baseValue: 0.083,
            highValue: 0.0415,
            displayValue: 0,
        },
        {
            name: "Taxa de Acerto",
            baseValue: 0.1,
            highValue: 0.05,
            displayValue: 0,
        },
        {
            name: "Taxa de Esquiva",
            baseValue: 0.05,
            highValue: 0.025,
            displayValue: 0,
        },
    ],
    intelligence: [
        {
            name: "Ataque Mágico",
            baseValue: 3.28,
            highValue: 1.63,
            displayValue: 0,
        },
        {
            name: "Taxa de Cura",
            baseValue: 6.9,
            highValue: 3.46,
            displayValue: 0,
        },
        {
            name: "Resfriamento",
            baseValue: 0.04,
            highValue: 0.02,
            displayValue: 0,
        },
        {
            name: "Perfuração Mágica",
            baseValue: 0.03,
            highValue: 0.015,
            displayValue: 0,
        },
    ],
    spirit: [
        {
            name: "MP Máximo",
            baseValue: 27.5,
            highValue: 13.75,
            displayValue: 0,
        },
        {
            name: "Recuperação de MP",
            baseValue: 3,
            highValue: 1.5,
            displayValue: 0,
        },
        {
            name: "Resistência à Status Anormais",
            baseValue: 0.1,
            highValue: 0.05,
            displayValue: 0,
        },
        {
            name: "Habilidade de Ataque",
            baseValue: 5.24,
            highValue: 2.62,
            displayValue: 0,
        },
    ],
    constitution: [
        {
            name: "HP Máximo",
            baseValue: 27.5,
            highValue: 13.75,
            displayValue: 0,
        },
        {
            name: "Recuperação de HP",
            baseValue: 3,
            highValue: 1.5,
            displayValue: 0,
        },
        {
            name: "Resistência à Ataque Crítico",
            baseValue: 0.072,
            highValue: 0.036,
            displayValue: 0,
        },
        {
            name: "Resistência à Ataque Duplo",
            baseValue: 0.03,
            highValue: 0.015,
            displayValue: 0,
        },
    ],
};
